import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Components
import SheetMenu, { SheetMenuItem } from '../structural/sheet/menu/SheetMenu';
import Icon from '../../components/icons/Icon';

// Utils
import { undoAction, redoAction } from '../../utils/undoRedo/undoRedoActions';
import { getUndoStack, getRedoStack } from '../../utils/undoRedo/undoRedoSelector';

type MobileGestureShakeContextMenuContentProps = {
    dispatchCloseSheet: () => void;
};

const MobileGestureShakeContextMenuContent = ({ dispatchCloseSheet }: MobileGestureShakeContextMenuContentProps) => {
    const dispatch = useDispatch();

    const undoStack = useSelector(getUndoStack);
    const redoStack = useSelector(getRedoStack);

    const handleUndo = () => {
        dispatch(undoAction());
        dispatchCloseSheet();
    };

    const handleRedo = () => {
        dispatch(redoAction());
        dispatchCloseSheet();
    };

    const menuItems: SheetMenuItem[] = [
        {
            label: 'Undo',
            icon: <Icon name="context-menu-undo" />,
            onClick: handleUndo,
            visible: undoStack?.size > 0,
        },
        {
            label: 'Redo',
            icon: <Icon name="context-menu-redo" />,
            onClick: handleRedo,
            visible: redoStack?.size > 0,
        },
    ];

    const hasAvailableActions = menuItems.some((item) => item.visible);

    if (!hasAvailableActions) {
        dispatchCloseSheet();
        return null;
    }

    return <SheetMenu menuItems={menuItems} />;
};

export default MobileGestureShakeContextMenuContent;
